<template>
  <el-container class="index-box">
    <el-aside width="asideWidth">
      <div class="logoStyle" v-show="!isCollapse">
       产 权 竞 价 系 统
      </div>
      <menus :isCollapse="isCollapse"/>
    </el-aside>
    <el-container>
      <el-header>
        <headers/>
      </el-header>
      <el-main>
        <router-view v-if="isRouterAlive"/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Menus from '@/components/menus/menus'
import Headers from '@/components/header/header'
export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
     
      isRouterAlive: true
    }
  },
  components: {
    Menus,
    Headers
  },
  created() {
     if(localStorage.getItem("token")==""||localStorage.getItem("token")==null||localStorage.getItem("token")=="undefined"){

      this.$router.push("/login");
     }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  },
  computed: {
    isCollapse () {
      return this.$store.state.isCollapse
    },
    asideWidth () {
      return this.$store.state.isCollapse ? 'auto' : '200px'
    }
  }
}
</script>

<style lang="scss" >
.index-box {
  font-family: serif;
  height: 100%;
  .el-container{
    height: 100%;
    .el-main {
      height: 100%;
    }
  }
  .el-aside {
    background-color: #20222A;
    height: 100vh;
    min-height: 100%;
    .logoStyle {
      background-color: #20222A;
      color: rgba(255,255,255,.8);
      text-align: center;
      height: 60px;
      padding-top: 16px;
      font-size: 16px;
      box-sizing: border-box;
      border-bottom: 1px solid gray;
    }
  }
  .el-header {
    border-bottom: 1px solid #f6f6f6;
    box-sizing: border-box;
    background-color: #fff;
    line-height: 60px;
  }
}
</style>
